import { usePermissions } from 'react-admin'

const useSettings = () => {
  const {
    isLoading,
    permissions,
  } = usePermissions()

  const driverType =  permissions?.driver_type
  const isBrokerDriver = driverType === 'broker'
  const isEmployeeDriver = driverType === 'employee'
  const tenantName = permissions?.tenant_name

  return {
    isBrokerDriver,
    isEmployeeDriver,
    tenantName,
    isLoading,
    driverType,
  }
}

export default useSettings
